

export default {
  name: 'BrandReviewsContent',
  props: {
    reviews: {
      type: Array,
      default() {
        return [];
      },
    },
    rating: {
      type: Object,
    },
    sortMode: {
      type: String,
    },
  },
  computed: {
    totalQty() {
      return this.rating.count;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    toggleReviews() {
      this.$emit('toggle-reviews', false);
    },
    changePage() {
      this.$emit('change-page');
    },
  },
};
